export const randomNumber = (min, max) => {
  return Math.random() * (max - min) + min
}
